import { useMenuItems } from '@crm/hooks/useMenuItems'
import { AppNames } from '@shared/types'

import { lazy } from 'react'

const AppRouter = lazy(() => import('./AppRouter'))

export const useCrmConfig = () => {
  const menuItems = useMenuItems()

  return {
    key: AppNames.Crm,
    path: '/apps/crm/:token/*',
    menu: menuItems,
    routes: <AppRouter />
  }
}
